export default "/_next/static/images/c5623a83e0e729c729b578d0fa4e1a63.png";